import React, { useEffect, useRef, useState } from "react";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import { Payment, PreviewPdf, StripeFixedFormFeilds, StripeForm } from "./interface";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { API_ROUTES } from "@/services/environment";
import { useAppDispatch, useAppSelector } from "@/hooks/hook";
import { GET, POST } from "@/services/api";
import Alert from "@/components/alert/Alert";
import useLoading from "@/hooks/useLoading";
import { Button, convertCentsToDollars, convertDollarToCents } from "@thdinc/hpf-shared";
import deleteIcon from '@/assets/icons/deleteIcon.svg'
import SelectSearchInput, { SelectInputHandle } from "@/components/selectInput/SelectSearchInput";
import { ADDITIONAL_BEVERAGES_DATA, COCKTAILS_TYPES_DATA } from "@/constants/CompanyData";
import { FiEdit2 } from "react-icons/fi";
import { resetPaymentFixedFormValues, resetPaymentForm, setFixedForm, setSpiritList } from "@/redux/slices/paymentFormSlice";
import { StoreList } from "../alcohalAndMixers/interface";
import { amountTaxRate, calculateBonus } from "@/utils";
import StyledSelect from "@/components/StyledSelect/StyledSelect";
interface StripeCompForm {
    paymentInfo: Payment;
    closeModal: () => void;
    renderFun: () => void;
    isOpen?: boolean;
    setIsOpen?: (isOpen: boolean) => void;
    paymentInvoiceId?: string;
    setPaymentInvoiceId?: (id: string) => void;
    setPreviewData: (params: PreviewPdf) => void;
    selectedStore: StoreList | undefined;
}
interface product {
    name: string;
    label?: string;
    value: string;
    type: string;
    price: string;
}

const StripePaymentForm: React.FC<StripeCompForm> = ({
    paymentInfo,
    closeModal,
    renderFun,
    setIsOpen,
    setPaymentInvoiceId,
    setPreviewData,
    selectedStore
}) => {
    const {
        formState: { errors, isValid },
        register,
        handleSubmit,
        reset,
        trigger,
        setValue,
        watch,
        control,
        getValues,
        resetField
    } = useForm<StripeForm>({
        defaultValues: {
            bottle_cost: undefined,
            number_of_bottles: undefined,
            spirit_type: 'vodka'
        },
    });
    const {
        register: registerFixed,
        handleSubmit: handleSubmitFixed,
        reset: resetFixed,
        trigger: triggerFixed,
        getValues: getValuesFixed,
        setValue: setValueFixed,
        setError: setErrorFixed,
        clearErrors: clearErrorsFixed,
        watch: watchFixed,
        control: controlFixed,
        formState: { errors: errorFixed },
    } = useForm<StripeFixedFormFeilds>();
    const { products, postPaymentChargeApi, productsPreferences, updateCustomerCard, getRewardPointsGlobalApi } = API_ROUTES;
    const { isLoading, startLoading, stopLoading } = useLoading();
    const [isProductLoading, setIsProductLoading] = useState<boolean>(false);
    const [isPreviewLoading, setIsPreviewLoading] = useState<boolean>(false);
    const [cardLoading, setCardLoading] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [productsList, setProductsList] = useState<product[]>([]);
    const [spiritList, setSpiritsList] = useState<StripeForm[]>([]);
    const [filteredProducts, setFilteredProducts] = useState<product[]>([]);
    const { refreshToken } = useAppSelector((store) => store.user);
    const [perfferedProduct, setPerfferedProduct] = useState([])
    const [spiritType, setSpiritType] = useState<string>('vodka')
    const [taxType, setTaxType] = useState<'rate' | 'fixed'>('rate')
    // extra states
    const numberOfBottles = watch("number_of_bottles");
    const bottleCost = watch("bottle_cost");
    const selectRef = useRef<any>(null);
    //redux state
    const dispatch = useAppDispatch();
    const paymentState = useAppSelector((state) => state.paymentForm);
    const spiritBonus = spiritList.reduce((acc, item) => { return acc + (Number(item.bonus) || 0) }, 0);
    const amountCharged = spiritList.reduce((acc, item) => { return acc + (Number(item.bottle_total_amount - item.item_tax_rate) || 0) }, 0);
    const taxRateTotal = spiritList.reduce((acc, item) => { return acc + (Number(item.item_tax_rate) || 0) }, 0);
    const watchHotPlatformFee = watchFixed('hot_platform_fee');
    const watchTaxRate = watchFixed('tax_rate');
    const watchStoreName = watchFixed('store_name');
    const watchStoreLocation = watchFixed('store_location');
    useEffect(() => {
        // hydrate spirit list
        if (paymentState.spiritList.length) {
            setSpiritsList(paymentState.spiritList);
        }
        // hydrate fixed form values
        Object.entries(paymentState.fixedForm).forEach(([key, value]) => {
            if (value !== undefined) {
                setValueFixed(key as keyof StripeFixedFormFeilds, value);
            }
        });
    }, []);
    useEffect(() => {
        if (!selectedStore?.id) return;
        (async () => {
            try {
                const res = await GET(`${productsPreferences}/${selectedStore.id}`, refreshToken);
                setPerfferedProduct(Array.isArray(res?.data) ? res.data : [])
            } catch (error) {
                Alert({ type: 'error', message: 'Unable to fetch product preferences' });
            }
        })();
    }, [selectedStore?.id])
    useEffect(() => {
        dispatch(setSpiritList(spiritList));
    }, [spiritList]);
    useEffect(() => {
        const subscription = watchFixed((value) => {
            dispatch(setFixedForm(value));
        });
        return () => subscription.unsubscribe();
    }, [watchFixed]);
    useEffect(() => {
        getProducts();
        selectedStore?.tax && setValueFixed('tax_rate', Number(selectedStore?.tax) ? selectedStore?.tax / 100 : 0)
    }, [paymentInfo?.business_id, selectedStore?.id]);
    useEffect(() => {
        const total = (Number(bottleCost) || 0) * (Number(numberOfBottles) || 0);
        setValue("bottle_total_amount", total);
    }, [bottleCost, numberOfBottles]);
    useEffect(() => {
        if (amountCharged >= 0) {
            const reduxHotPlatformFee = paymentState.fixedForm.hot_platform_fee || 0;
            setValueFixed("bartender_company_fee", parseFloat((spiritBonus).toFixed(2)));
            /*when user clicks on Add button else statement executes and if statements executes
             when user comes from any navigation so we get value from the redux*/
            if (paymentState.fixedForm.tax_rate !== undefined && paymentState.fixedForm.tax_rate !== null) {
                setValueFixed('tax_rate', Number(paymentState.fixedForm.tax_rate));
            }
            /*when user clicks on Add button else statement executes and if statements executes
             when user comes from any navigation so we get value from the redux*/
            const currentHotPlatformFee = Number(getValuesFixed('hot_platform_fee')) || 0;
            if (reduxHotPlatformFee != 0) {
                setValueFixed("hot_platform_fee", paymentState.fixedForm.hot_platform_fee || 0);
                setValueFixed("total_amount_charged", amountCharged + reduxHotPlatformFee + taxRateTotal);
            } else if (currentHotPlatformFee != 0) {
                setValueFixed("hot_platform_fee", currentHotPlatformFee);
                setValueFixed("total_amount_charged", amountCharged + currentHotPlatformFee + taxRateTotal);
            } else {
                setValueFixed("hot_platform_fee", 0);
                setValueFixed("total_amount_charged", amountCharged + taxRateTotal);
            }
        }
        if (spiritList.length === 0) {
            const storeName = getValuesFixed('store_name');
            const storeLocation = getValuesFixed('store_location');
            resetFixed();
            if (storeName) setValueFixed('store_name', storeName);
            if (storeLocation) setValueFixed('store_location', storeLocation);
        }
    }, [spiritList]);
    useEffect(() => {
        let taxes = 0;
        if (amountCharged) {
            taxes = Number(getValuesFixed('hot_platform_fee')) + Number(taxRateTotal);
            setValueFixed('total_amount_charged', amountCharged + taxes)
            setValueFixed("bartender_company_fee", parseFloat((spiritBonus).toFixed(2)));
        }
    }, [watchHotPlatformFee, watchTaxRate, isEdit])
    const handleOpen = () => {
        selectRef.current?.openDropdown();
    };
    useEffect(() => {
        if (spiritType && productsList.length > 0) {
            const filtered = productsList.filter((p) => p.type === spiritType);
            setFilteredProducts(filtered?.concat({
                name: 'Other',
                label: 'Other',
                value: 'other',
                type: 'other',
                price: '0'
            }));
        } else {
            setFilteredProducts([])
        }
    }, [spiritType, productsList]);
    const getProducts = async () => {
        try {
            setIsProductLoading(true);
            const result = await GET(`${products}/${selectedStore?.id}`, refreshToken);
            const prodcuts = Array.isArray(result?.data)
                ? result.data.map((product: any) => ({
                    name: product.name,
                    value: product.id,
                    type: product.type,
                    price: product.price,
                }))
                : [];
            setProductsList(prodcuts);
        } catch (err) {
            console.log(String(err));
        } finally {
            setIsProductLoading(false);
        }
    };
    const onSubmit: SubmitHandler<StripeForm> = async (data: StripeForm) => {
        dispatch(resetPaymentFixedFormValues())
        handleOpen();
        setValue('id', spiritList.length + 1);
        setSpiritType('vodka');
        const taxValue = Number(getValuesFixed('tax_rate'));
        const itemTaxRate = taxValue > 0
            ? taxType === 'rate'
                ? (taxValue / 100) * data.bottle_total_amount
                : taxValue
            : 0;
        setSpiritsList((prev) => [...prev, {
            ...{
                ...data,
                bonus: calculateBonus(data.bottle_total_amount, data.bonus),
                item_tax_rate: itemTaxRate,
                bottle_total_amount: data.bottle_total_amount + itemTaxRate
            },
            id: spiritList.length + 1
        }]);
        reset();
    };
    const onEditSubmit: SubmitHandler<StripeForm> = async (data: StripeForm) => {
        const taxValue = Number(getValuesFixed('tax_rate'));
        const itemTaxRate = taxValue > 0
            ? taxType === 'rate'
                ? (taxValue / 100) * data.bottle_total_amount
                : taxValue
            : 0;
        setSpiritsList((prev) =>
            prev.map((item) =>
                item.id === data.id ? {
                    ...item,
                    ...{
                        ...data,
                        bonus: data.bonus,
                        item_tax_rate: itemTaxRate,
                        bottle_total_amount: data.bottle_total_amount + itemTaxRate
                    }
                } : item
            )
        );
        setIsEdit(false);
        reset();
    };
    const onTableSubmit = async (data: StripeFixedFormFeilds, isPreview?: boolean) => {
        const valid = await triggerFixed();
        if (valid) {
            const updatedspiritList = spiritList.map(({ id, brand, ...rest }: any) => (
                { ...rest, product_id: brand?.value, product_name: brand?.name }
            ));
            if (isPreview) {
                setIsPreviewLoading(true);
                let alcoholAmountPointsRatio = 0;
                try {
                    const res = await GET(`${getRewardPointsGlobalApi}/${paymentInfo.business_id}`, refreshToken);
                    alcoholAmountPointsRatio = res?.data?.record?.alcohol_amount_points_ratio ?? 0;
                } catch (error) {
                    alcoholAmountPointsRatio = 0;
                } finally {
                    setIsPreviewLoading(false);
                }
                const pointsToBeEarned = Math.ceil(Number(data.bartender_company_fee || 0) * alcoholAmountPointsRatio);
                setPreviewData({
                    isPreview: true,
                    invoiceData: {
                        total_amount_charged: String(data.total_amount_charged),
                        preview_amount_charged: String(amountCharged + taxRateTotal),
                        sub_total_charged: String(amountCharged),
                        hot_platform_fee: String(data.hot_platform_fee),
                        bartender_company_fee: String(data.bartender_company_fee),
                        tax_rate: String(Number(data.tax_rate)),
                        taxRateTotal: String(Number(taxRateTotal)),
                        storeId: selectedStore?.id,
                        spiritList: updatedspiritList,
                        total_bonus: String(spiritBonus),
                        selectedStore: selectedStore,
                        store_name: data.store_name,
                        store_location: data.store_location,
                        points_to_be_earned: String(pointsToBeEarned),
                    }
                })
            } else {
                const formData = new FormData();
                //table array values
                updatedspiritList.forEach((item, index) => {
                    formData.append(`alcoholCharge[${index}][bottle_cost]`, convertDollarToCents(item.bottle_cost));
                    formData.append(`alcoholCharge[${index}][number_of_bottles]`, item.number_of_bottles);
                    formData.append(`alcoholCharge[${index}][bottle_total_amount]`, convertDollarToCents(item.bottle_total_amount));
                    formData.append(`alcoholCharge[${index}][spirit_type]`, item.spirit_type);
                    formData.append(`alcoholCharge[${index}][tax]`, convertDollarToCents(item.item_tax_rate));
                    if (item.product_id == 'other') {
                        formData.append(`alcoholCharge[${index}][product_id]`, String(null));
                        formData.append(`alcoholCharge[${index}][name]`, item.brandName);
                    } else {
                        formData.append(`alcoholCharge[${index}][product_id]`, item.product_id);
                        formData.append(`alcoholCharge[${index}][name]`, item.product_name);
                    }
                });
                //fixed values
                formData.append("business_id", String(paymentInfo.business_id));
                formData.append("booking_id", String(paymentInfo.id));
                formData.append("total_amount_charged", convertDollarToCents(String(data.total_amount_charged)));
                formData.append("hot_platform_fee", convertDollarToCents(String(data.hot_platform_fee)));
                formData.append("tax_rate", convertDollarToCents(String(taxRateTotal)));
                formData.append("bartender_company_fee", convertDollarToCents(String(data.bartender_company_fee)));
                formData.append("total_bonus", convertDollarToCents(String(spiritBonus)))
                formData.append("HOWS", String(true));
                formData.append("store_name", String(selectedStore?.name));
                formData.append("store_alcohol_location", String(data.store_location));
                formData.append("store_name_alcohol", String(data.store_name));

                startLoading();
                try {
                    const res = await POST(`${postPaymentChargeApi}/${selectedStore?.id}`, formData, refreshToken);
                    if (res.data) {
                        if (res.data.success) {
                            resetFixed();
                            dispatch(resetPaymentForm());
                            reset();
                            setIsOpen?.(true)
                            setPaymentInvoiceId?.(res.data?.transcationId);
                            Alert({ message: res?.data?.message });
                        } else {
                            Alert({ type: "error", message: res?.data?.message ?? "Something went wrong" });
                        }
                    }
                } catch (error) {
                    Alert({ type: "error", message: "Something went wrong" });
                } finally {
                    stopLoading();
                }
            }
        }
    }
    const handleBrandOption = (filterProducts: product[]) => {
        const preferredIds = new Set(
            (perfferedProduct as any[]).map((p) => p.prefer1?.id).filter(Boolean)
        );
        const sortedProducts = [...filterProducts].sort((a, b) => {
            const aIsPreferred = preferredIds.has(a.value) ? 1 : 0;
            const bIsPreferred = preferredIds.has(b.value) ? 1 : 0;
            return bIsPreferred - aIsPreferred;
        });
        return sortedProducts.map(p => ({ label: p.name, value: p.value }))
    }
    const isPreferredProduct = (selectedValue: any) => {
        for (const product of perfferedProduct as any) {
            if (product.prefer1?.id === selectedValue.value) {
                return { bonus: product.bonus, is_prefer: true };
            }
            // else if (product.prefer2?.id === selectedValue.value) {
            //   return product.bonus;
            // } else if (product.prefer3?.id === selectedValue.value) {
            //   return product.bonus;
            // }
        }
        return { bonus: 0, is_prefer: false };
    };
    const handleCardChange = async () => {
        try {
            setCardLoading(true);
            const res = await GET(`${updateCustomerCard}/${paymentInfo?.id}`, refreshToken);
            if (res.data) {
                if (res.data.success) {
                    Alert({ message: res?.data?.message });
                } else {
                    Alert({ type: "error", message: res?.data?.message ?? "Something went wrong" });
                }
            }
        } catch (error) {
            Alert({ type: "error", message: "Something went wrong" });
        }
        finally {
            setCardLoading(false);
        }
    }

    return (
        <div>
            <form>
                <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-3">
                    <div className=" w-full">
                        <p className="font-semibold  text-xs mb-2 ml-4 ">Store Name</p>
                        <Controller
                            name="store_name"
                            control={controlFixed}
                            rules={{ required: "Store name is required" }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <input
                                        type="text"
                                        {...field}
                                        value={field.value ?? ""}
                                        className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                        placeholder="Store Name"
                                    />
                                    <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                        {error?.message}
                                    </p>
                                </>
                            )}
                        />
                    </div>
                    <div className="w-full">
                        <p className="font-semibold  text-xs mb-2 ml-4 ">Store Location</p>
                        <Controller
                            name="store_location"
                            control={controlFixed}
                            rules={{ required: "Store location is required" }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <ReactGoogleAutocomplete
                                        apiKey={process.env.REACT_APP_PLACES_API}
                                        onPlaceSelected={(place: any) => {
                                            field.onChange(place.formatted_address ?? "");
                                        }}
                                        defaultValue={field.value ?? ""}
                                        className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                        placeholder="Search Location"
                                        options={{ types: ["geocode", "establishment"] }}
                                    />
                                    <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                        {error?.message}
                                    </p>
                                </>
                            )}
                        />
                    </div>
                </div>
                <div className="text-primary-red text-xs flex justify-end mb-3">
                    <p>Total Amount to Charge: {getValuesFixed('total_amount_charged') && `$${getValuesFixed('total_amount_charged')?.toFixed(2)}`}</p>
                </div>
                <div className="flex flex-col gap-4 sm:flex-row sm:gap-8">
                    <div className="w-full">
                        <p className="font-semibold  text-xs mb-2 ml-4 ">HOT Platform Fee<span className="text-white max-[375px]:hidden">&#160;&#160;&#160;&#160;&#160;&#160;</span></p>
                        <input
                            type="number"
                            maxLength={21}
                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                            placeholder={"HOT Platform Fee"}
                            {...registerFixed("hot_platform_fee", {
                                required: "HOT platform fee is required",
                                min: {
                                    value: 0,
                                    message: "Amount must be greater than 0 ",
                                },
                                onChange: async (e) => {
                                    const hotPlatformFee = e.target.value;
                                    if (hotPlatformFee.length > 15) {
                                        e.target.value = hotPlatformFee.slice(0, 15);
                                    }
                                    const decimalIndex = hotPlatformFee.indexOf('.');
                                    if (decimalIndex >= 0 && hotPlatformFee.length - decimalIndex > 3) {
                                        e.target.value = hotPlatformFee.slice(0, decimalIndex + 3);
                                    }
                                }
                            })}
                        />
                        <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                            {errorFixed?.hot_platform_fee?.message}
                        </p>
                    </div>
                    <div className="w-full">
                        <p className="font-semibold text-xs mb-2 ml-4 ">{paymentInfo?.business_name} Points (5%)</p>
                        <input
                            type="number"
                            maxLength={21}
                            className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                            placeholder={"Bartending Company Fee"}
                            {...registerFixed("bartender_company_fee", {
                                required: "Bartender company fee is required",
                                min: {
                                    value: 0,
                                    message: "Amount must be greater than 0 ",
                                },
                                onChange: async (e) => {
                                    const value = e.target.value;
                                    if (Number(value) >= Number(amountCharged + taxRateTotal)) {
                                        setErrorFixed("bartender_company_fee", {
                                            type: "manual",
                                            message: "BC fee cannot be greater than total amount charged",
                                        });
                                    } else {
                                        clearErrorsFixed("bartender_company_fee");
                                    }
                                    if (value.length > 15) {
                                        e.target.value = value.slice(0, 15);
                                    }
                                    const decimalIndex = value.indexOf('.');
                                    if (decimalIndex >= 0 && value.length - decimalIndex > 3) {
                                        e.target.value = value.slice(0, decimalIndex + 3);
                                    }
                                }
                            })}
                        />
                        <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                            {errorFixed?.bartender_company_fee?.message}
                        </p>
                    </div>
                </div>
            </form>
            <form onSubmit={handleSubmit(isEdit ? onEditSubmit : onSubmit)}>
                <div className="text-primary-red text-xs flex justify-end mt-4">
                    <p>Total Amount: {Number(bottleCost) * Number(numberOfBottles) > 0 ? `$${(Number(bottleCost) * Number(numberOfBottles)).toFixed(2)}` : ""}</p>
                </div>
                <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-3">
                    <div className=" w-full">
                        <p className="font-semibold  text-xs mb-2 ml-4 ">Alcohol Type</p>
                        <Controller
                            name="spirit_type"
                            control={control}
                            rules={{ required: "Spirit type is required" }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <SelectSearchInput
                                        placeholder="Select Spirit Type"
                                        options={[
                                            ...COCKTAILS_TYPES_DATA
                                                .filter(item => item.value !== "other"),
                                            ...ADDITIONAL_BEVERAGES_DATA]}
                                        value={field.value}
                                        ref={selectRef}
                                        defaultValue={COCKTAILS_TYPES_DATA[1].value}
                                        onChange={(selectedValue: string) => {
                                            setSpiritType(selectedValue)
                                            field.onChange(selectedValue);
                                            const filtered = productsList?.filter((p) => p.type === selectedValue);
                                            setFilteredProducts(filtered?.concat({
                                                name: 'Other',
                                                label: 'Other',
                                                value: 'other',
                                                type: 'other',
                                                price: '0'
                                            }));
                                            resetField('brand')
                                            resetField('bottle_cost')
                                            resetField('number_of_bottles')
                                        }}
                                    />
                                    <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                        {error?.message}
                                    </p>
                                </>
                            )}
                        />
                    </div>
                    <div className=" w-full">
                        <p className="font-semibold  text-xs mb-2 ml-4 ">Brand</p>
                        <Controller<StripeForm, 'brand'>
                            name="brand"
                            control={control}
                            rules={{ required: "Brand name is required" }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <StyledSelect
                                        options={handleBrandOption(filteredProducts)}
                                        value={field?.value ? { label: field?.value.name, value: field?.value.value } : undefined}
                                        isLoading={isProductLoading}
                                        onChange={async (selectedValue) => {
                                            const selectedOption = filteredProducts.find((opt) => opt.value === selectedValue.value);
                                            if (selectedOption) {
                                                field.onChange({
                                                    name: selectedOption.name,
                                                    value: selectedOption.value,
                                                });
                                                selectedOption?.price &&
                                                    setValue('bottle_cost', Number(convertCentsToDollars(String(selectedOption.price))));
                                            } else {
                                                field.onChange(null);
                                            }
                                            const product = isPreferredProduct(selectedValue)
                                            setValue('is_prefer', product.is_prefer)
                                            if (product.bonus > 0) {
                                                setValue('bonus', product.bonus / 100)
                                            }
                                            await trigger('brand');
                                            await trigger('bonus');
                                        }}
                                        data-testid="search-id"
                                        placeholder={"Select Brand"}
                                        isCustomComponent
                                        preferedProduct={perfferedProduct}
                                    />
                                    <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                        {error?.message}
                                    </p>
                                </>)}
                        />
                    </div>
                    {getValues('brand.name') == 'Other' && <div className=" w-full">
                        <p className="font-semibold  text-xs mb-2 ml-4 ">Brand Name</p>
                        <Controller
                            name="brandName"
                            control={control}
                            rules={{ required: "Brand Name is required" }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <input
                                        type="text"
                                        maxLength={50}
                                        {...field}
                                        value={field.value ?? ""}
                                        onInput={async (e: any) => {
                                            const value = e.target.value;
                                            field.onChange(value);
                                            await trigger('brandName');
                                        }}
                                        className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                        placeholder="Enter Brand Name"
                                    />
                                    <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                        {error?.message}
                                    </p>
                                </>
                            )}
                        />
                    </div>}
                </div>
                <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-3">
                    <div className=" w-full">
                        <p className="font-semibold  text-xs mb-2 ml-4 ">Bottle Cost</p>
                        <Controller
                            name="bottle_cost"
                            control={control}
                            rules={{
                                required: "Bottle cost is required",
                                min: { value: 0, message: "Cost must be greater than 0" }
                            }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <input
                                        type="number"
                                        step="0.01"
                                        {...field}
                                        value={field.value ?? ""}
                                        onInput={async (e: any) => {
                                            const value = e.target.value;
                                            if (value.length > 15) {
                                                e.target.value = value.slice(0, 15);
                                            }
                                            const decimalIndex = value.indexOf('.');
                                            if (decimalIndex >= 0 && value.length - decimalIndex > 3) {
                                                e.target.value = value.slice(0, decimalIndex + 3);
                                            }
                                            field.onChange(value);
                                            await trigger('bottle_cost');
                                        }}
                                        className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                        placeholder="Enter Amount"
                                    />
                                    <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                        {error?.message}
                                    </p>
                                </>
                            )}
                        />
                    </div>
                    <div className="w-full">
                        <p className="font-semibold  text-xs mb-2 ml-4 ">No. of Bottles</p>
                        <Controller
                            name="number_of_bottles"
                            control={control}
                            rules={{
                                required: "Number of bottles is required",
                                min: { value: 0, message: "Amount must be greater than 0" }
                            }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        {...field}
                                        value={field.value || ""}
                                        onInput={async (e: any) => {
                                            e.target.value = e.target.value.replace(/\D/g, '');
                                            field.onChange(e.target.value);
                                            await trigger('number_of_bottles');
                                        }}
                                        maxLength={15}
                                        className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                        placeholder="Enter Amount"
                                    />
                                    <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                        {error?.message}
                                    </p>
                                </>
                            )}
                        />
                    </div>
                </div>
                <div className="w-full flex justify-end">
                    <Button
                        disabled={!isValid || !watchStoreName || !watchStoreLocation}
                        className={`text-center  px-6 rounded-full mt-2 py-2 ${isValid && watchStoreName && watchStoreLocation
                            ? "bg-primary-red hover:bg-primary-red-button-hover text-white"
                            : "bg-gray-300 text-gray-500  "
                            } `}>
                        {isEdit ? "Edit" : "Add"}
                    </Button>
                </div>
                <div className="flex flex-col gap-4 sm:flex-row sm:gap-8">
                    <div className="w-full">
                        <div className="flex items-center gap-3 mb-2 ml-1">
                            <span className={`text-xs font-semibold ${taxType === 'rate' ? 'text-primary-red' : 'text-gray-400'}`}>Tax Rate (%)</span>
                            <button
                                type="button"
                                onClick={() => {
                                    const next = taxType === 'rate' ? 'fixed' : 'rate';
                                    setTaxType(next);
                                    setValueFixed('tax_rate', 0);
                                    clearErrorsFixed('tax_rate');
                                }}
                                className="relative w-11 h-6 rounded-full bg-primary-red transition-colors focus:outline-none flex-shrink-0"
                            >
                                <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200 ${taxType === 'fixed' ? 'translate-x-5' : 'translate-x-0'}`} />
                            </button>
                            <span className={`text-xs font-semibold ${taxType === 'fixed' ? 'text-primary-red' : 'text-gray-400'}`}>Fixed Amount ($)</span>
                        </div>
                        <input
                            type="number"
                            step="any"
                            maxLength={21}
                            className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                            placeholder={taxType === 'rate' ? 'Enter Percentage' : 'Enter Amount'}
                            {...registerFixed("tax_rate", {
                                min: {
                                    value: 0,
                                    message: "Tax value must be greater than or equal to 0",
                                },
                                validate: (value) => {
                                    if (taxType === 'rate' && Number(value) > 100) {
                                        return "Tax rate must be less than or equal to 100";
                                    }
                                    return true;
                                },
                                onChange: async (e) => {
                                    const taxRate = e.target.value;
                                    if (taxRate.length > 15) {
                                        e.target.value = taxRate.slice(0, 15);
                                    }
                                    const decimalIndex = taxRate.indexOf('.');
                                    if (decimalIndex >= 0 && taxRate.length - decimalIndex > 3) {
                                        e.target.value = taxRate.slice(0, decimalIndex + 3);
                                    }
                                    await triggerFixed('tax_rate')
                                }
                            })}
                        />
                        <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                            {errorFixed?.tax_rate?.message}
                        </p>
                    </div>
                    <div className="w-full"></div>
                </div>
                {spiritList?.length > 0 &&
                    <>
                        <div className="relative overflow-x-auto  rounded-md mt-4 overflow-y-auto max-h-full border">
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                                <thead className="text-xs text-[#606060] uppercase bg-[#E5E7EB]">
                                    <tr>
                                        <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                                            Spirit Type
                                        </th>
                                        <th scope="col" className=" sm:px-3 py-4 uppercase text-center">
                                            Brand
                                        </th>
                                        <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                                            Bottle Cost
                                        </th>
                                        <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                                            No. of Bottles
                                        </th>
                                        <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                                            Sub Total
                                        </th>
                                        <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                                            Tax Amount
                                        </th>
                                        <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                                            Total Amount
                                        </th>{" "}
                                        <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {spiritList.map((item: StripeForm, index) => {
                                        return (
                                            <tr key={index} className="bg-white 0  border-b">
                                                <td className="sm:px-7 py-4  min-w-32 text-center">
                                                    {item?.spirit_type?.charAt(0).toUpperCase() + item?.spirit_type?.slice(1)}
                                                </td>
                                                {
                                                    item?.brand?.name === 'Other' ?
                                                        <td className="sm:px-7 py-4  min-w-32 text-center">
                                                            {item?.brandName?.charAt(0).toUpperCase() + item?.brandName?.slice(1)}
                                                        </td>
                                                        :
                                                        <td className={`sm:px-3 py-4 min-w-32 text-center ${item?.is_prefer && 'text-primary-red'}`}>
                                                            {item?.is_prefer ? `${item?.brand?.name} (Preferred)` : item?.brand?.name}
                                                        </td>
                                                }
                                                <td className="sm:px-2 py-4 min-w-32 text-center">
                                                    <p>{Number(item.bottle_cost).toFixed(2)}</p>
                                                </td>
                                                <td className="sm:px-2 py-4 min-w-32 text-center">
                                                    <p>{Number(item.number_of_bottles)}</p>
                                                </td>
                                                <td className="sm:px-2 py-4 min-w-32 text-center">
                                                    <p>{(Number(item.number_of_bottles) * Number(item.bottle_cost)).toFixed(2)}</p>
                                                </td>
                                                <td className="sm:px-2 py-4 min-w-32 text-center">
                                                    <p>{Number(item.item_tax_rate).toFixed(2)}</p>
                                                </td>
                                                <td className="sm:px-2 py-4 min-w-32 text-center">
                                                    <p>{Number(item.bottle_total_amount).toFixed(2)}</p>
                                                </td>
                                                <td className=" sm:px-2 py-4 min-w-32 text-center">
                                                    <div className="flex justify-center items-center gap-2">
                                                        <span className="p-1 cursor-pointer"
                                                            onClick={async () => {
                                                                setValue("spirit_type", item.spirit_type);
                                                                setValue("brandName", item.brandName);
                                                                setValue("brand", item.brand);
                                                                setValue("bonus", item.bonus);
                                                                setValue("bottle_cost", item.bottle_cost);
                                                                setValue("number_of_bottles", item.number_of_bottles);
                                                                setValue("bottle_total_amount", item.bottle_total_amount);
                                                                setValue("id", item.id);
                                                                dispatch(resetPaymentFixedFormValues())
                                                                const filtered = item.spirit_type !== 'other'
                                                                    ? productsList.filter((p) => p.type === item.spirit_type)
                                                                    : productsList;
                                                                setFilteredProducts(filtered?.concat({
                                                                    name: 'Other',
                                                                    label: 'Other',
                                                                    value: 'other',
                                                                    type: 'other',
                                                                    price: '0'
                                                                }));
                                                                await trigger();
                                                                if (spiritList.length > 0) {
                                                                    setIsEdit(true);
                                                                }
                                                            }}>
                                                            <FiEdit2 size={14} />
                                                        </span>
                                                        <span className="p-1 cursor-pointer"
                                                            onClick={async () => {
                                                                dispatch(resetPaymentFixedFormValues())
                                                                setSpiritsList((prev) => prev.filter((_, i) => i !== index));
                                                                if (spiritList.length === 1) {
                                                                    setIsEdit(false);
                                                                }
                                                                await triggerFixed('total_amount_charged')
                                                            }}>
                                                            <img src={deleteIcon} />
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-end">
                            {/* <Button
                type="button"
                onClick={() => handleCardChange()}
                className={`text-center px-6 my-5 mr-3 rounded-full py-2 ${"bg-primary-red hover:bg-primary-red-button-hover text-white"}`}>
                {cardLoading ? "Updating..." : "Update Card"}
              </Button> */}
                            <Button
                                type="button"
                                disabled={isPreviewLoading}
                                onClick={() => onTableSubmit(getValuesFixed(), true)}
                                className={`text-center px-6 my-5 mr-3 rounded-full py-2 ${"bg-primary-red hover:bg-primary-red-button-hover text-white"}`}>
                                {isPreviewLoading ? "Loading..." : "Preview"}
                            </Button>
                            <Button
                                type="button"
                                disabled={isLoading}
                                onClick={() => onTableSubmit(getValuesFixed(), false)}
                                className={`text-center px-6 my-5 rounded-full py-2 ${"bg-primary-red hover:bg-primary-red-button-hover text-white"}`}>
                                {isLoading ? "Processing..." : "Charge"}
                            </Button>
                        </div>
                    </>
                }
            </form>
        </div >
    );
};

export default StripePaymentForm;
